module.exports = __webpack_public_path__ + "img/project-12.03150d6c.jpg";